module.exports = __webpack_public_path__ + "static/media/sappa_logo.09d91481.png";